import React from 'react';

const Dash=React.lazy(()=>import('./Dash'));
const Projects=React.lazy(()=>import('./Projects'))
export {
    Dash,
    Projects
}